import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultEnum } from "../../types.client";
import { RfMagneticFieldMeasure } from "../../../models/schemas/measures/rfCard.schema";
import { RF_MAGNETIC_FIELD_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * RF카드 자기장 세기 컨트롤러
 * 판정 기준: RF_MAGNETIC_FIELD_THRESHOLDS.min <= measuredValue <= RF_MAGNETIC_FIELD_THRESHOLDS.max
 */
export class RfMagneticFieldController extends MeasureController<RfMagneticFieldMeasure> {
  protected getDefaultData(): RfMagneticFieldMeasure {
    return {
      label: "",
      measuredValue: 0,
      unit: "A/m",
      photo: { checkUrl: "", resultUrl: "" },
      result: null,
      discussion: "",
      remark: "",
      createdAt: null,
    };
  }

  protected judge(): JudgmentResult {
    const value = this.data.measuredValue ?? 0;

    // 값이 0이면 NA
    if (value === 0) {
      return {
        result: JudgmentResultEnum.NA,
        discussion: this.generateDiscussion(JudgmentResultEnum.NA),
      };
    }

    // min <= value <= max 이면 GOOD
    const { min, max } = RF_MAGNETIC_FIELD_THRESHOLDS;
    if (value >= min && value <= max) {
      return {
        result: JudgmentResultEnum.GOOD,
        discussion: this.generateDiscussion(JudgmentResultEnum.GOOD),
      };
    }

    // 범위 밖이면 BAD
    return {
      result: JudgmentResultEnum.BAD,
      discussion: this.generateDiscussion(JudgmentResultEnum.BAD),
    };
  }

  protected generateDiscussion(result: "GOOD" | "CAUTION" | "BAD" | "NA"): string {
    const value = this.data.measuredValue ?? 0;

    if (result === JudgmentResultEnum.NA) {
      return "측정값이 입력되지 않았습니다.";
    }

    const { min, max } = RF_MAGNETIC_FIELD_THRESHOLDS;
    if (result === JudgmentResultEnum.GOOD) {
      return `자기장 세기 ${value}A/m는 정상 범위(${min}~${max}A/m)입니다.`;
    }

    return `자기장 세기 ${value}A/m는 기준 범위(${min}~${max}A/m)를 벗어났습니다.`;
  }
}
